import classNames from 'classnames';
import propTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';

const SwitchToggle = (props) => {
    if (props.title) {
      return (
        <Container>
          <Row>
              <Col md={3} sm={3} xs={4} className={classNames("switch__wrapper", {"is-disabled": props.disabled})}>
                <div
                  onClick={props.disabled? null : props.onClick}
                  className={classNames("switch__wrapper_background")}
                >
                  <div
                    className={classNames("switch__wrapper_background_circle",
                      `circle_${props.color}`,
                      {"active": props.active})}
                    style={props.style}
                  />
                </div>
              </Col>
              <Col md={9} sm={9} xs={8} className="switch__text">
                <p>{props.title}</p>
              </Col>
          </Row>
        </Container>
      )
    } else {
      return (
        <>
          <Row>
            <Col className={classNames("switch__wrapper", {"is-disabled": props.disabled})}>
              <div
                onClick={props.disabled? null : props.onClick}
                className={classNames("switch__wrapper_background")}
              >
                <div
                  className={classNames("switch__wrapper_background_circle",
                    `circle_${props.color}`,
                    {"active": props.active})}
                  style={props.style}
                />
              </div>
            </Col>
          </Row>
        </>
      )
    }
  }

SwitchToggle.defaultProps = {
  color: 'green',
  active: false
}

SwitchToggle.propTypes = {
  style: propTypes.object,
  title: propTypes.string,
  onClick: propTypes.func,
  active: propTypes.bool,
  color: propTypes.oneOf(['green'])
}

export default SwitchToggle;